module.exports = __webpack_public_path__ + "img/21.8a36e05b.jpg";